import type { Customer } from "src/services/customerService";
import { getFromLocal } from "src/util/cache.service";
import { LOCAL_KEYS, USER_ROLE } from "src/util/util.constant";

const normalizeRole = (value: unknown) =>
  String(value ?? "")
    .toLowerCase()
    .replace(/[\s_-]/g, "");

const authorizedRoles = [
  USER_ROLE.CRMAdmin,
  USER_ROLE.CRMUser,
  USER_ROLE.SuperUser,
  USER_ROLE.RootrUser,
].map(normalizeRole);

const distributorSelectableRoles = [
  USER_ROLE.SuperUser,
  USER_ROLE.RootrUser,
].map(normalizeRole);

export const getCurrentUserRole = () =>
  normalizeRole(getFromLocal<unknown>(LOCAL_KEYS.ROLE, false, true));

export const canMoveCustomerVehicles = (role = getCurrentUserRole()) =>
  authorizedRoles.includes(normalizeRole(role));

export const canSelectMoveDistributor = (role = getCurrentUserRole()) =>
  distributorSelectableRoles.includes(normalizeRole(role));

export const getCustomerDistributorId = (
  customer?: Customer | null,
): string | number | undefined => {
  const directId = customer?.distributorId;
  if (typeof directId === "string" || typeof directId === "number") {
    return directId;
  }

  const distributor = customer?.distributor;
  if (typeof distributor === "string" || typeof distributor === "number") {
    return distributor;
  }

  if (distributor && typeof distributor === "object" && "id" in distributor) {
    const id = (distributor as { id?: unknown }).id;
    if (typeof id === "string" || typeof id === "number") return id;
  }

  return undefined;
};
